import { Injectable } from "@angular/core";
import { SubjectsService } from "@carnegie-learning/data-access-angular-cure";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import * as activeSubjectsActions from "../actions/active-subjects.action";

@Injectable()
export class ActiveSubjectsEffects {
    constructor(
        private actions$: Actions,
        private subjectsService: SubjectsService
    ) {}

    loadActiveSubjects$ = createEffect(() =>
        this.actions$
            .pipe(ofType(activeSubjectsActions.LoadActiveSubjects))
            .pipe(
                switchMap(action => {
                    return this.subjectsService.getActiveSubjects().pipe(
                        map(subjects =>
                            activeSubjectsActions.LoadActiveSubjectsSuccess({
                                payload: subjects
                            })
                        ),
                        catchError(error =>
                            of(
                                activeSubjectsActions.LoadActiveSubjectsFail({
                                    payload: error
                                })
                            )
                        )
                    );
                })
            )
    );
}
